import React from 'react';

/**
 * Dashboard-shell skeleton (Master Plan §1.5).
 *
 * Shown while a role dashboard chunk loads (Suspense fallback) so the app
 * presents the shape of the destination — sidebar, header, content cards —
 * instead of a bare spinner or a blank gateway screen. Purely presentational:
 * no data, no hooks, safe to render in any shell (applicant / admin /
 * employer / referrer / sponsor all share this layout family).
 */
export default function ShellSkeleton() {
  return (
    <div className="app-shell" role="status" aria-live="polite" aria-label="Loading your dashboard">
      <div className="app-canvas">
        {/* Sidebar column (hidden on small screens, like the real shells) */}
        <div className="hidden md:flex w-60 shrink-0 flex-col gap-3 border-r border-slate-200/70 bg-white/60 p-4" aria-hidden="true">
          <div className="h-9 w-32 rounded-xl bg-slate-200/80 animate-pulse" />
          <div className="mt-4 space-y-2">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-9 rounded-xl bg-slate-200/60 animate-pulse" style={{ animationDelay: `${i * 90}ms` }} />
            ))}
          </div>
        </div>
        <div className="flex-1 min-w-0 h-full min-h-0 flex flex-col">
          {/* Header row */}
          <div className="flex items-center justify-between gap-3 px-4 sm:px-6 py-4" aria-hidden="true">
            <div className="space-y-2">
              <div className="h-5 w-48 rounded-lg bg-slate-200/80 animate-pulse" />
              <div className="h-3 w-32 rounded-lg bg-slate-200/60 animate-pulse" />
            </div>
            <div className="h-10 w-10 rounded-full bg-slate-200/80 animate-pulse" />
          </div>
          {/* Content cards */}
          <div className="flex-1 min-h-0 px-4 sm:px-6 pb-6 space-y-4 overflow-hidden" aria-hidden="true">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[0, 1, 2].map((i) => (
                <div key={i} className="h-24 rounded-2xl bg-slate-200/60 animate-pulse" style={{ animationDelay: `${i * 120}ms` }} />
              ))}
            </div>
            <div className="h-64 rounded-2xl bg-slate-200/50 animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
